import HelpLink from "./HelpLink";

export default function helpMessages(id) {
    const data = {
        // Filters
        "filters-general":
        {
            "title": "Building a Target Audience",
            "message": <>
                <p>Filters are how you define your target audience. AudienceMaker uses two filtering systems within the platform to build audiences: {' '}
                    <HelpLink url="/articles/building-an-audience-with-simple-filters/" text="simple filters"/>
                    {' '} and {' '}
                    <HelpLink url="/articles/building-an-audience-with-complex-filters/" text="complex filters"/>.
                </p>
            </>,
            "url": "/topics/building-a-target-audience/"
        },
        "complex-filters":
        {
            "title": "Complex Filters",
            "message": "Complex filters have more logic and nesting of filtering rules, so you can create powerful AND/OR/NOT filters that are then subtracted (filtered) from the total audience count.",
            "url" : "/articles/building-an-audience-with-complex-filters/"
        },
        "selection-match-level":
        {
            "title": "Selection Match Level",
            "message": <>
                <p>Match Levels are how you determine at what level your selection matches to your target audience.</p>
                    <ul>
                        <li><strong>Individual</strong> requires a match on first name, last name, and address.<br/><br/></li>
                        <li><strong>Household</strong> requires a match on last name and address.<br/><br/></li>
                        <li><strong>Address</strong> requires a match at the address only.</li>
                    </ul>
            </>
        }
    };
    return data[id];
}